import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '120px',
    color: theme.palette.common.white,
    background: '#335387',
    '&:hover': {
      background: '#2a3f6b'
    }
  }
}))

interface PropTypes {
  onClick?: () => void
  icon: string
  text: string
}

const LiveControlAdminButton: React.FC<PropTypes> = (props) => {
  const classes = useStyles()
  const { icon, onClick, text } = props

  return (
    <Button
      classes={classes}
      onClick={onClick}
    >
      <img src={icon} alt="xs" height={34} />
      {text}
    </Button>
  )
}

export default React.memo(LiveControlAdminButton)
